// extracted by mini-css-extract-plugin
export default {"infoLabel":"Region_infoLabel__++Q0I","required":"Region_required__5Z-oz","inputWrapper":"Region_inputWrapper__kcFAE"};